module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/price-config-active.dd2cecd5.svg";